import { combineReducers } from "@reduxjs/toolkit";

import { MainSearchSource, MainSearchSuggestionsScope } from "@/shop/api/mainSearch";

import { createMainSearchFilterReducer } from "./filters/reducer";
import { default as query } from "./query/reducer";
import { createMainSearchInitialState, createMainSearchResultReducer } from "./results/reducer";
import { createMainSearchSuggestionInitialState, createMainSearchSuggestionResultReducer } from "./suggestionResults/reducer";

const suggestionResults = combineReducers({
  [MainSearchSuggestionsScope.CustomerMaterialNumber]: createMainSearchSuggestionResultReducer(
    createMainSearchSuggestionInitialState(MainSearchSuggestionsScope.CustomerMaterialNumber)
  ),
  [MainSearchSuggestionsScope.MaterialNumber]: createMainSearchSuggestionResultReducer(
    createMainSearchSuggestionInitialState(MainSearchSuggestionsScope.MaterialNumber)
  ),
  [MainSearchSuggestionsScope.Orders]: createMainSearchSuggestionResultReducer(createMainSearchSuggestionInitialState(MainSearchSuggestionsScope.Orders)),
  [MainSearchSuggestionsScope.Quotes]: createMainSearchSuggestionResultReducer(createMainSearchSuggestionInitialState(MainSearchSuggestionsScope.Quotes)),
  [MainSearchSuggestionsScope.Category]: createMainSearchSuggestionResultReducer(createMainSearchSuggestionInitialState(MainSearchSuggestionsScope.Category)),
  [MainSearchSuggestionsScope.OriginalSupply]: createMainSearchSuggestionResultReducer(
    createMainSearchSuggestionInitialState(MainSearchSuggestionsScope.OriginalSupply)
  ),
  [MainSearchSuggestionsScope.IBase]: createMainSearchSuggestionResultReducer(createMainSearchSuggestionInitialState(MainSearchSuggestionsScope.IBase)),
  [MainSearchSuggestionsScope.FrsProduct]: createMainSearchSuggestionResultReducer(
    createMainSearchSuggestionInitialState(MainSearchSuggestionsScope.FrsProduct)
  ),
  [MainSearchSuggestionsScope.CeSparepart]: createMainSearchSuggestionResultReducer(
    createMainSearchSuggestionInitialState(MainSearchSuggestionsScope.CeSparepart)
  ),
  [MainSearchSuggestionsScope.FavList]: createMainSearchSuggestionResultReducer(createMainSearchSuggestionInitialState(MainSearchSuggestionsScope.FavList)),
  [MainSearchSuggestionsScope.Configurator]: createMainSearchSuggestionResultReducer(
    createMainSearchSuggestionInitialState(MainSearchSuggestionsScope.Configurator)
  ),
  [MainSearchSuggestionsScope.Service]: createMainSearchSuggestionResultReducer(createMainSearchSuggestionInitialState(MainSearchSuggestionsScope.Service)),
  [MainSearchSuggestionsScope.ToscotecSp]: createMainSearchSuggestionResultReducer(
    createMainSearchSuggestionInitialState(MainSearchSuggestionsScope.ToscotecSp)
  ),
  [MainSearchSuggestionsScope.OemSpareParts]: createMainSearchSuggestionResultReducer(
    createMainSearchSuggestionInitialState(MainSearchSuggestionsScope.OemSpareParts)
  )
});

const results = combineReducers({
  [MainSearchSource.Category]: createMainSearchResultReducer(createMainSearchInitialState(MainSearchSource.Category)),
  [MainSearchSource.OriginalSupply]: createMainSearchResultReducer(createMainSearchInitialState(MainSearchSource.OriginalSupply)),
  [MainSearchSource.Parts]: createMainSearchResultReducer(createMainSearchInitialState(MainSearchSource.Parts)),
  [MainSearchSource.Orders]: createMainSearchResultReducer(createMainSearchInitialState(MainSearchSource.Orders)),
  [MainSearchSource.Quotes]: createMainSearchResultReducer(createMainSearchInitialState(MainSearchSource.Quotes)),
  [MainSearchSource.iBase]: createMainSearchResultReducer(createMainSearchInitialState(MainSearchSource.iBase)),
  [MainSearchSource.FrsProduct]: createMainSearchResultReducer(createMainSearchInitialState(MainSearchSource.FrsProduct)),
  [MainSearchSource.CeSparepart]: createMainSearchResultReducer(createMainSearchInitialState(MainSearchSource.CeSparepart)),
  [MainSearchSource.FavList]: createMainSearchResultReducer(createMainSearchInitialState(MainSearchSource.FavList)),
  [MainSearchSource.Configurator]: createMainSearchResultReducer(createMainSearchInitialState(MainSearchSource.Configurator)),
  [MainSearchSource.Service]: createMainSearchResultReducer(createMainSearchInitialState(MainSearchSource.Service)),
  [MainSearchSource.ToscotecSp]: createMainSearchResultReducer(createMainSearchInitialState(MainSearchSource.ToscotecSp)),
  [MainSearchSource.OemSpareParts]: createMainSearchResultReducer(createMainSearchInitialState(MainSearchSource.OemSpareParts))
});

const filters = combineReducers({
  [MainSearchSource.Category]: createMainSearchFilterReducer(MainSearchSource.Category),
  [MainSearchSource.OriginalSupply]: createMainSearchFilterReducer(MainSearchSource.OriginalSupply),
  [MainSearchSource.Parts]: createMainSearchFilterReducer(MainSearchSource.Parts),
  [MainSearchSource.Orders]: createMainSearchFilterReducer(MainSearchSource.Orders),
  [MainSearchSource.Quotes]: createMainSearchFilterReducer(MainSearchSource.Quotes),
  [MainSearchSource.iBase]: createMainSearchFilterReducer(MainSearchSource.iBase),
  [MainSearchSource.FrsProduct]: createMainSearchFilterReducer(MainSearchSource.FrsProduct),
  [MainSearchSource.CeSparepart]: createMainSearchFilterReducer(MainSearchSource.CeSparepart),
  [MainSearchSource.FavList]: createMainSearchFilterReducer(MainSearchSource.FavList),
  [MainSearchSource.Configurator]: createMainSearchFilterReducer(MainSearchSource.Configurator),
  [MainSearchSource.ToscotecSp]: createMainSearchFilterReducer(MainSearchSource.ToscotecSp),
  [MainSearchSource.OemSpareParts]: createMainSearchFilterReducer(MainSearchSource.OemSpareParts)
});

export default combineReducers({
  query,
  suggestionResults,
  results,
  filters
});
